import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { BaseCard, BaseCardBody, BaseCardHeader } from '@unite-us/ui';
import { createContactCommunications } from 'actions/Contact/Group';
import Message from 'common/form/Interactions/Message';
import AddCirclePlusButton from 'common/display/Profile/components/AddCirclePlusButton';
import { useInvalidateQueries } from 'src/api/APIHooks';
import Messages from 'src/components/Notes/Messages';
import { submitMessage } from 'src/components/Facesheet/Overview/components/actions/useFacesheetInteractions';

export function MessagesSection({
  contact,
  providerId,
  createContactCommunications: createContactCommunicationsAction,
}) {
  const [showMessageInteraction, setShowMessageInteraction] = useState(false);
  const invalidateQueries = useInvalidateQueries();

  const submitFunction = useMemo(
    () => (values) => submitMessage({
      values,
      contact,
      invalidateQueries,
      createContactCommunications: createContactCommunicationsAction,
    }),
    [contact, createContactCommunicationsAction, invalidateQueries],
  );

  if (!contact?.id) {
    return null;
  }

  const openMessageComposer = () => setShowMessageInteraction(true);
  const closeMessageComposer = () => setShowMessageInteraction(false);

  return (
    <BaseCard>
      <BaseCardHeader title={<span className="text-base font-semibold leading-6 text-brand-blue">Messages</span>}>
        <AddCirclePlusButton
          id="add-social-care-plan-message-button"
          labelText="Message Client"
          addHandler={openMessageComposer}
        />
      </BaseCardHeader>
      <BaseCardBody>
        <div className="px-5 py-5">
          {showMessageInteraction && (
            <div className="mb-4">
              <Message
                contact={contact}
                submitFunction={submitFunction}
                cancelFunction={closeMessageComposer}
              />
            </div>
          )}
          <Messages
            subject={contact.id}
            providerId={providerId}
            onAddNote={openMessageComposer}
            showHeader={false}
            compactBottomSpacing
          />
        </div>
      </BaseCardBody>
    </BaseCard>
  );
}

MessagesSection.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string,
  }),
  providerId: PropTypes.string.isRequired,
  createContactCommunications: PropTypes.func.isRequired,
};

MessagesSection.defaultProps = {
  contact: null,
};

const mapStateToProps = (state) => ({
  providerId: state.session.groupId,
});

export default connect(mapStateToProps, {
  createContactCommunications,
})(MessagesSection);
